module.exports = __webpack_public_path__ + "static/media/sanguo-2.9c2a26d4.png";